module.exports = function (fox) {
	var foxValidatorShim = require('./foxValidatorShim')(fox);

	return fox.extend(function FormElementValidator (element) {
		this.element = element;
		
		this._checkers = [];
		this._resultHistory = {};
		this._inProgress = {};
	}, {
		/**
		 * 
		 * @param {function} fn (value, <FormElementValidator>): {result:boolean, message:string}
		 */
		addChecker: function (checker) {
			if (fox.isObject(checker))
				checker = foxValidatorShim(checker);

			if (fox.isFunction(checker) && !fox.inArray(this._checkers, checker)) {
				var checkerIndex = this._checkers.push(checker) - 1;

				checker.toString = function () { return 'checker_' + checkerIndex; };
			}

			return false;
		},

		validate: function (value) {
			if (!this._checkers.length)
				return fox.Promise.resolve({result: true});

			if (fox.isPromise(value))
				return value.then(function (resp) {
					return this._validate(resp);
				}.bind(this));

			return this._validate(value);
		},

		_validate: function (value) {
			var _this = this;
			var inProgress = this._inProgress;
			var hash = this._generateHash(value);

			if (hash in this._resultHistory)
				return fox.Promise.resolve(this._resultHistory[hash]);

			function addInProgress(id, nextResult, value) {
				nextResult.__value = value;

				inProgress[id] = nextResult;

				return nextResult.then(function (result) {
					delete inProgress[id];

					return result;
				}).catch(function (error) {
					delete inProgress[id];

					throw error;
				});
			}

			return this._checkers.reduce(function (prevPromise, next, idx) {
				return prevPromise.then(function (resp) {
					if (resp.result === false)
						return resp;

					var nextId = next.toString();

					if (nextId in inProgress) {
						var inProgressValue = inProgress[nextId].__value;

						return inProgress[nextId].then(function (resp) {
							if (inProgressValue !== value)
								return addInProgress(nextId, next(value, _this), value);

							return resp;
						});
					}

					var nextResult = next(value, _this);

					if (!fox.isPromise(nextResult))
						return nextResult;

					return addInProgress(nextId, nextResult, value);
				});
			}, fox.Promise.resolve({ result: true })).then(function (resp) {
				if (hash)
					this._resultHistory[hash] = resp;

				return resp;
			}.bind(this));
		},

		resetResultCache: function (value) {
			if (!fox.isUndefined(value)) {
				var hash = this._generateHash(value);

				if (hash in this._resultHistory)
					return delete this._resultHistory[hash];
			}

			this._resultHistory = {};

			return true;
		},

		_generateHash: function (value) {
			var hash = null;

			if (fox.isNumeric(value))
				hash = fox.getStringSimpleHash(value.toString());

			if (fox.isString(value))
				hash = fox.getStringSimpleHash(value);

			if (fox.isObject(value) || fox.isArray(value))
				hash = fox.getStringSimpleHash(JSON.stringify(value));

			return hash;
		}
	}, null, 'FormElementValidator')
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/validator/elementValidator.js
// module id = 92
// module chunks = 0